import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { WithTheme } from '../styles/theme';

export interface IButtonProps {
  color?: 'primary' | 'default' | 'transparent';
  outlined?: boolean;
  small?: boolean;
}

const colors = {
  primary: css`
    background-color: ${({ theme }) => theme.palette.foreground.cta};
    border-color: ${({ theme }) => theme.palette.foreground.cta};
    color: ${({ theme }) => theme.palette.foreground.primary};
  `,
  default: css`
    background-color: ${({ theme }) => theme.palette.foreground.primary};
    border-color: ${({ theme }) => theme.palette.foreground.primary};
    color: ${({ theme }) => theme.palette.background.card};
    ${({ outlined, theme }: WithTheme<IButtonProps>) =>
      outlined &&
      css`
        color: ${theme.palette.foreground.primary};
      `}
  `,
  transparent: css`
    background-color: transparent;
    border-color: transparent;
    color: ${({ theme }) => theme.palette.foreground.primary};
  `,
};

const getButtonColors = <TProps extends WithTheme<IButtonProps>>({
  color = 'default',
}: TProps) => color && colors[color];

const buttonBaseStyles = css`
  ${getButtonColors}
  display: inline-flex;
  min-height: 3rem;
  min-width: 10rem;
  box-sizing: border-box;
  padding: 0.9375rem; /* 1 - border-width */
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-style: solid;
  border-width: 0.125rem;
  border-radius: 0.5rem;
  font-family: ${({ theme }) => theme.typography.heading.fontFamily};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1rem;
  text-decoration: none;
  cursor: pointer;
  outline: none;

  ${({ outlined }: IButtonProps) =>
    outlined &&
    css`
      background-color: transparent;
    `};

  ${({ small }: IButtonProps) =>
    small &&
    css`
      padding: 0.5rem 1rem;
      min-height: 2rem;
      border-radius: 0.25rem;
      font-weight: 500;
    `};
`;

export const Button = styled.button`
  ${buttonBaseStyles}
`;

export const LinkButton = styled(Link)`
  ${buttonBaseStyles}
`;

export const AnchorLinkButton = styled.a`
  ${buttonBaseStyles}
`;
